import React from 'react';
import ZipCodeAssignmentTable from './components/ZipcodeAssignmentTable/ZipCodeAssignmentTable';

const ZipCodeAssignmentList = () => {
  return <ZipCodeAssignmentTable />;
};

export default ZipCodeAssignmentList;
